import * as L from 'leaflet';
import { FaMarker, MarkerLayer } from 'src/app/bgsLeaflet/public_api';

export class PlacedPinMapLayer extends MarkerLayer {
  constructor(latLng?: L.LatLng) {
    super('placed_pin', 'Placed Pin');
    this.toggleable.set(false);

    this.setDefaultIcon(new FaMarker().configure(['fas', 'fa-long-arrow-alt-down'], '#002e40', 80, 36));

    if (null != latLng) {
      this.addMarker('placed_pin', latLng.lat, latLng.lng);
    }
  }
}
